import React from 'react'
import styled from 'styled-components'

const StyledHorizon = styled.div`
  width: 20rem;
  height: 20rem;
  border-radius: 50%;
  z-index: -1000000;
  display: none;
`
const InnerCircle = styled.div`
  background: linear-gradient(135deg, #ff8660 0%, #ffd5af 100%);
  opacity: 0.8;
  width: 15rem;
  height: 15rem;
  border-radius: 50%;
  position: absolute;
  top: 2.5rem;
  left: 2.5rem;
`

const Circle = styled.div`
  background: linear-gradient(135deg, #ff5721 0%, #ffa179 100%);
  opacity: 0.3;
  width: 20rem;
  height: 20rem;
  border-radius: 50%;
`

const Horizon = () => (
  <StyledHorizon>
    <Circle />
    <InnerCircle />
  </StyledHorizon>
)

export default Horizon
